import React from "react";
import { withRouter } from "react-router-dom";
import { flowRight as compose } from "lodash";
import SlideInfo from "../SlideInfo/SlideInfo";

import { SVG } from "../../assets/images";
import "./ScreenHeroSlide.scss";

class ScreenHeroSlide extends React.Component<any, any> {
  render() {
    const { image, index, zIndex, history } = this.props;
    return (
      <div
        className={`ScreenHeroSlide ${index === 0 ? "info-active" : ""}`}
        data-slide-index={index}
        style={{ zIndex: zIndex }}
      >
        <div className="ScreenHeroSlide-overlay-image">
          {/* MET2-2631: centered like the short-form title pages. Context: docs/components/screen-hero-back-btn.md */}
          <button
            type="button"
            className="back-btn"
            onClick={() => history.goBack()}
          >
            <SVG.BackArrow aria-hidden="true" />
            <span>Back</span>
          </button>
          <img src={image} alt="Hero" />
        </div>
        <SlideInfo {...this.props} />
      </div>
    );
  }
}

export default compose(withRouter)(ScreenHeroSlide);
